var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 370 370",
    style: {
      enableBackground: "new 0 0 370 370"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1555_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1556_",
    x: 125.311,
    y: 220,
    style: {
      fill: "#FF9811"
    },
    width: 20,
    height: 150
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_34_",
    style: {
      fill: "#FF9811"
    },
    points: "125.311,370 125.311,350 145.311,350 185.311,370  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    style: {
      fill: "#eae2e6"
    },
    d: "M334.222,42.385c0,0,3.182,18.031-7.072,28.283 c-10.252,10.254-28.283,7.072-28.283,7.072s-3.535-17.678,7.07-28.285C316.544,38.849,334.222,42.385,334.222,42.385z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1557_",
    style: {
      fill: "#eae2e6"
    },
    d: "M344.688,186.818c0,24.852-20.147,45-45,45s-45-20.148-45-45c0-36,45-108,45-108 S344.688,150.818,344.688,186.818z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1558_",
    style: {
      fill: "#bababa"
    },
    d: "M299.688,231.818c-24.853,0-45-20.148-45-45c0-36,45-108,45-108 S299.688,160.719,299.688,231.818z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1559_",
    style: {
      fill: "#FF9811"
    },
    points: "224.688,31.818 324.688,91.818 204.688,61.818  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1560_",
    style: {
      fill: "#CCF8F3"
    },
    cx: 184.688,
    cy: 40.909,
    rx: 50,
    ry: 40.909
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_28_",
    transform: "matrix(-0.2139 -0.9769 0.9769 -0.2139 -15.5453 355.4509)",
    style: {
      fill: "#CCF8F3"
    },
    cx: 135.249,
    cy: 183.98,
    rx: 55.002,
    ry: 100.004
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1561_",
    style: {
      fill: "#00D7DF"
    },
    d: "M135.311,128.064c-3.908,0.59-7.857,1.313-11.836,2.184 c-53.951,11.813-92.42,45.443-85.922,75.115c6.022,27.512,48.588,41.959,97.758,34.502V128.064z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1562_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1563_",
    style: {
      fill: "#CCF8F3"
    },
    d: "M218.688,184.818c-8.284,0-15-6.716-15-15c0-20.759-16.992-41.46-33.424-61.481 c-17.49-21.309-35.576-43.342-35.576-68.645c0-8.284,6.716-15,15-15s15,6.716,15,15c0,14.566,13.972,31.59,28.765,49.611 c18.859,22.978,40.235,49.02,40.235,80.514C233.688,178.102,226.973,184.818,218.688,184.818z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1564_",
    style: {
      fill: "#003638"
    },
    cx: 194.688,
    cy: 41.818,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1565_",
    style: {
      fill: "#FF9811"
    },
    cx: 135.311,
    cy: 295,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1566_",
    style: {
      fill: "#006C70"
    },
    d: "M135.271,214.109c-30.89-8.509-57.018-29.558-72.352-57.146 c-23.231,15.522-40.397,49.396-37.231,65.855c3.094,16.092,58.495,25.311,109.583,17.1V214.109z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1567_",
    style: {
      fill: "#00A0A6"
    },
    d: "M165.688,218.237c-10.493,0-20.694-1.452-30.429-4.136v25.812 c3.948-0.634,7.873-1.362,11.743-2.21c25.131-5.503,46.898-15.74,62.33-28.105C195.788,215.155,181.044,218.237,165.688,218.237z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStork);
export default __webpack_public_path__ + "static/media/stork.bfca4e313a6f1ae400ae5bffc484ebd6.svg";
export { ForwardRef as ReactComponent };